module.exports = __webpack_public_path__ + "static/image/help_center_effect_evaluation.svg?2849df9a0dbe1ebd18c2e2dd9e7ca94e";